import { loadingTypes } from '@/constants/loadingTypes';

import { ApiBase } from './api-base';

/**
 * @template R
 * @typedef {import('axios').AxiosResponse<R>} AxiosResponse<R>
 */
/**
 * @typedef {import('@/models/estimate-roles.interface').EstimationRoles} EstimationRoles
 */

export class EstimationRolesApi extends ApiBase {
  /**
   * @private
   * @readonly
   */
  ESTIMATION_ROLE_API_ROOT = 'estimation-roles';

  /**
   * Get single estimate by id
   * @param {string} id estimate id
   * @returns {Promise<AxiosResponse<EstimationRoles>>}
   */
  getRole = (id) => this.apiClient.sendRequest({
    method: 'GET',
    url: `${this.ESTIMATION_ROLE_API_ROOT}/${id}`,
  }, { loadingType: loadingTypes.syncEmployeeButton });

  /**
   * Get multiple employees by project id or office ids
   * @param {GetEmployeesParams} [params={}] project id or offices ids
   * @returns {Promise<AxiosResponse<EstimationRoles[]>>}
   */
  getRoles = ({ projectId } = {}) => this.apiClient.sendRequest({
    method: 'GET',
    url: `${this.ESTIMATION_ROLE_API_ROOT}/`,
    params: {
      project_id: projectId,
    },
  }, { loadingType: loadingTypes.none });

  deleteProjectEstimateRole = (estimateID) => this.apiClient.sendRequest({
    method: 'DELETE',
    url: `${this.ESTIMATION_ROLE_API_ROOT}/${estimateID}`,
  });

  addProjectEstimateRole = (role) => this.apiClient.sendRequest({
    method: 'POST',
    url: `${this.ESTIMATION_ROLE_API_ROOT}/`,
    data: role,
  });

  changeProjectEstimateRole = (roleID, role) => this.apiClient.sendRequest({
    method: 'PUT',
    url: `${this.ESTIMATION_ROLE_API_ROOT}/${roleID}`,
    data: role,
  }, { loadingType: loadingTypes.none });
}
